import { render, staticRenderFns } from "./transfer-group.vue?vue&type=template&id=d0d739fa"
import script from "./transfer-group.vue?vue&type=script&lang=js"
export * from "./transfer-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports